import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { propTypes } from 'react-bootstrap/esm/Image';


export default function IpgTransactionStateCombo(props) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(props.value);

    useEffect(() => {
        var states = [
            {id:0, title:"همه موارد"},
            {id:util.IpgTransactionStates.Accepted, title:"تائید شده"},
            {id:util.IpgTransactionStates.Request, title:"خطا، تا مرحله درخواست"},
            {id:util.IpgTransactionStates.WaitToVerify, title:"خطا، وریفای نشده"},
            {id:util.IpgTransactionStates.Failed, title:"سایر خطاها"},
        ];
        setItems(states);
        setItem({id:0, title:"همه موارد"})
    }, []);
    const getItem = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].id == id) return items[i];
        }
        return null;
    }

    const onItemChanged = function (ii){
        if(!ii) ii = null;
        console.log("selected service is>", ii);
        if(props.onChange){
            if(ii == null){
                props.onChange(null);
            }
            else{
                props.onChange(ii);
            }
            
        }
    }


    return(
        <>
        {
            <>
            <Row style={{marginTop:"20px"}}>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="cmb" value={item} onChange={(e) => {setItem(e.value); onItemChanged(e.value);}} options={items} optionLabel="title" className="w-full rtl-dropdown" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loading} scrollHeight="350px"    
                            />
                            <label htmlFor="cmb">وضعیت تراکنش</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            </>
        }
        </>
    )
}